import { Card, Grid, Text } from "@mantine/core";
import Image from "next/image";
import { Languages } from "./Languages";
import { SpecialistData } from "../../../hooks/react-query/useSpecialistList";
import { MyButton } from "../../UI/my-button/MyButton";
import { IconCalendarEvent } from "@tabler/icons";
import { useColors } from "../../../hooks/colors/useColors";
import { ButtonLink } from "../../UI/button-link/ButtonLink";
import { useTranslation } from "next-i18next";
import { Fragment } from "react";
import { mobile, tablet } from "../../../constants/env";

type InputProps = {
  specialist: SpecialistData;
  showButtons?: boolean;
};

export function SpecialistInfo(props: InputProps) {
  const { specialist, showButtons } = props;
  const { colors } = useColors();
  const { t } = useTranslation("common");
  let imageClass = "p-0 relative w-[320px] h-[400px]";
  if (!mobile) imageClass = "p-0 relative w-[450px] h-[600px]";
  if (tablet) imageClass = "p-0 relative w-[480px] h-[650px]";

  return (
    <Fragment>
      {specialist.image && specialist.image.length > 10 && (
        <Grid className="m-6 items-center">
          <Grid.Col
            span={{ base: 12, lg: 6 }}
            className="flex justify-center lg:mb-4"
          >
            <Card className={imageClass} radius="xs" shadow="md">
              <Image
                priority
                alt="Person"
                src={specialist.image}
                sizes="450px 270px 180px"
                fill
                style={{
                  objectFit: "cover",
                }}
              />
            </Card>
          </Grid.Col>
          <Grid.Col
            span={{ base: 12, lg: 6, xl: showButtons ? 6 : 4 }}
            className="flex flex-col justify-center text-center h-full items-center"
          >
            <Grid className="m-6">
              <Grid.Col span={12}>
                <h2
                  style={{
                    fontFamily: "RocknRoll One",
                    fontSize: 30,
                    fontWeight: 800,
                  }}
                >
                  {specialist.name}
                </h2>
              </Grid.Col>
              <Grid.Col span={12}>
                <Text className="text-[20px] !font-bold">
                  {specialist.description}
                </Text>
                <Text className="!my-4 text-center flex items-center justify-center gap-4 text-[20px]">
                  {specialist.type === "doctor" && (
                    <Image
                      alt="Ordem dos medicos"
                      height={30}
                      width={150}
                      src="/img/ordem-medicos.png"
                    />
                  )}
                  {specialist.type !== "doctor" && (
                    <Image
                      alt={specialist.name}
                      height={100}
                      width={100}
                      src="/img/ordem-psicologos.png"
                    />
                  )}
                  {`Nº ${specialist.medicalOrderId}`}
                </Text>
                <Languages specialist={specialist} />
                <Text
                  // style={{ background: colors.white }}
                  className="text-center p-4 dark-text font-bold dark:!text-gray-200"
                  dangerouslySetInnerHTML={{
                    __html: specialist.secondaryDescription,
                  }}
                />
              </Grid.Col>
              {showButtons && (
                <Fragment>
                  <Grid.Col span={{ base: 12, lg: 6 }}>
                    <div className="flex justify-center my-8 gap-4">
                      <ButtonLink
                        href={`/specialists/${specialist.urlSlug}`}
                        color={colors.secondary}
                        title={t("find-out")}
                        rounded
                      />
                    </div>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, lg: 6 }}>
                    <div className="flex justify-center my-8 gap-4">
                      <MyButton
                        rounded
                        height={50}
                        fontSize={20}
                        onClick={() => {}}
                        title={t("book-app")}
                        icon={<IconCalendarEvent color="white" />}
                        color={colors.secondary}
                      />
                    </div>
                  </Grid.Col>
                </Fragment>
              )}
            </Grid>
          </Grid.Col>
        </Grid>
      )}
    </Fragment>
  );
}
